<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-small-size-100 tagline">
      <h2><b>Account created successfully</b></h2>
      <h3>
        <b>
          We've sen't you a confirmation email, please open your mailbox to
          activate your account.
        </b>
      </h3>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style></style>
